import React from 'react';

import { capitalize } from 'lodash/fp';

import { Currency } from '@/constants';
import { truncateMidAddressInputValue } from '@/utils';

import BuildDetailsCopyBadge from '../components/BuildDetailsCopyBadge';
import BuildDetailsGrid, { BuildDetailsGridLabelValuePair } from '../components/BuildDetailsGrid';

import BuildDetailsTokenInfoL2ContractModule, {
  L2ContractDetailsModule,
} from './BuildDetailsTokenInfoL2ContractModule';
import BuildDetailsTokenInfoL2ContractModuleInstance from './BuildDetailsTokenInfoL2ContractModuleInstance';

const BuildDetailsTokenInfoL2Contract: React.FC<{
  currency: Currency;
  l2ContractProp: string;
  l2ContractData: { id: string };
}> = ({ currency, l2ContractProp, l2ContractData }) => {
  if (!l2ContractData) return null;

  const { id, ...rest } = l2ContractData;

  return (
    <BuildDetailsGrid
      collapsible
      content={
        <ul>
          {Object.entries(rest).map(([key, value]) => {
            if (key === 'module') {
              return (
                <React.Fragment key={l2ContractProp.concat('-', currency)}>
                  <BuildDetailsTokenInfoL2ContractModule module={value as L2ContractDetailsModule} />
                  <BuildDetailsTokenInfoL2ContractModuleInstance module={value as L2ContractDetailsModule} />
                </React.Fragment>
              );
            }
          })}
        </ul>
      }
    >
      <BuildDetailsGridLabelValuePair
        label={l2ContractProp.split('_').map(capitalize).join(' ')}
        value={
          id?.startsWith('0x') ? (
            <BuildDetailsCopyBadge value={id} maskValue={(value) => truncateMidAddressInputValue(String(value), 24)} />
          ) : (
            id
          )
        }
      />
    </BuildDetailsGrid>
  );
};

export default BuildDetailsTokenInfoL2Contract;
